// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

	if(document.querySelector('.privary-navigation__submenu')){
		document.querySelectorAll('.privary-navigation__submenu').forEach((submenu)=>{
			submenu.classList.add('hidden');
		});

		let openNavs = document.querySelectorAll('.js-open-sub');

		openNavs.forEach((button)=>{
			button.addEventListener('click',(e)=>{
				e.preventDefault();
				button.classList.toggle('active');
				button.nextElementSibling.classList.toggle('hidden');
			})

			if(button.nextElementSibling.querySelector('.privary-navigation__item a.active')){
				button.classList.add('active');
				button.nextElementSibling.classList.remove('hidden');
			}
		})
	}

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_first_name').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_last_name').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

	if(document.querySelector('.tabs-quad')){
		let tabsQuad = document.querySelectorAll('.tabs-quad__filter li');
		let itemsQuad = document.querySelectorAll('.tabs-quad__item');
		let lastClickTab = null;

		tabsQuad.forEach((tab)=>{
			tab.addEventListener('click', ()=>{
				let dataTab = tab.dataset.tab;
				tab.classList.add('active');
				if(lastClickTab){
					lastClickTab.classList.remove('active');
				}
				itemsQuad.forEach((item)=>{
					item.classList.toggle('hidden', item.dataset.tab != dataTab);
				})
				lastClickTab = tab;
			})
		})
		tabsQuad[0].click();
	}

	if(document.querySelector('.js-open-select-booking')){
		document.querySelectorAll('.js-open-select-booking').forEach((button)=>{
			button.addEventListener('click',()=>{
				document.getElementById('booking-select').classList.add('show');
			})
		})
	}

	if(document.querySelector('.js-close-booking')){
		document.querySelector('.js-close-booking').addEventListener('click',()=>{
			document.getElementById('booking-select').classList.remove('show');
		})
	}

	if(document.querySelector('.js-open-menu')){
		document.querySelector('.js-open-menu').addEventListener('click',()=>{
			document.getElementById('menu-site').classList.add('show');
		})
	}

	if(document.querySelector('.js-close-menu')){
		document.querySelector('.js-close-menu').addEventListener('click',()=>{
			document.getElementById('menu-site').classList.remove('show');
		})
	}

	if(document.querySelector('.featured-items')){
		let allQuadsFeatured = document.querySelectorAll('.featured-items__item');

		allQuadsFeatured.forEach((quad)=>{
			quad.addEventListener('mouseenter',()=>{
				quad.querySelector('.featured-items__content .copy').classList.add('active');
			});

			quad.addEventListener('mouseleave',()=>{
				quad.querySelector('.featured-items__content .copy').classList.remove('active');
			})
		})
	}

	document.querySelectorAll('.accordion').forEach((accordion) => {
		accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
			itemHead.addEventListener('click', (e) => {
				accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
					if (itemHead.parentNode !== item) item.classList.remove('open');
				});
				itemHead.parentNode.classList.toggle('open');
			});
		});
	});

	if(document.querySelector('.form-module-wrapper')){
		document.querySelectorAll('.form-module-wrapper').forEach((text) => {
			text.querySelector('.form-module').classList.add('animate-fade','top');
		});
	}

	if(document.querySelector('.text-modules-wrapper')){
		document.querySelectorAll('.text-modules-wrapper').forEach((text) => {
		text.querySelector('.text-modules').classList.add('animate-fade','top');
	});
	}

	if(document.querySelector('.global-sitemap')){
		document.querySelector('.global-sitemap').classList.add('animate-fade', 'top');
	}


})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}


/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
	const menu = document.querySelector('#menu-site');
	const isMenuVisible = menu && menu.classList.contains('show');
	const elements = document.querySelectorAll('#menu-site .privary-navigation__item a, #menu-site .social-media a, #menu-site .secondary-navigation__item a');


		elements.forEach(element => {
			element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
		});
	}
	document.addEventListener('DOMContentLoaded', () => {
	updateMenuTabIndex();


	document.addEventListener('focusin', updateMenuTabIndex);
	const menu = document.querySelector('#menu-site');
	if (menu) {
		menu.addEventListener('transitionend', updateMenuTabIndex);
	}
});


